import { useEffect, useState } from "react";

import { updateEmailSettings } from "../../services/settingsApi";

function EmailSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        smtpHost: "",
        smtpPort: "",
        smtpUser: "",
        smtpPassword: "",
        fromEmail: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                smtpHost: settings.smtpHost || "",
                smtpPort: settings.smtpPort || "",
                smtpUser: settings.smtpUser || "",
                smtpPassword: settings.smtpPassword || "",
                fromEmail: settings.fromEmail || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateEmailSettings(formData);

            alert("Email settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update email settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Email (SMTP) Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>SMTP Host</label>

                        <input
                            type="text"
                            name="smtpHost"
                            value={formData.smtpHost}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>SMTP Port</label>

                        <input
                            type="number"
                            name="smtpPort"
                            value={formData.smtpPort}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>SMTP Username</label>

                        <input
                            type="text"
                            name="smtpUser"
                            value={formData.smtpUser}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>SMTP Password</label>

                        <input
                            type="password"
                            name="smtpPassword"
                            value={formData.smtpPassword}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>From Email</label>

                        <input
                            type="email"
                            name="fromEmail"
                            value={formData.fromEmail}
                            onChange={handleChange}
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Email Settings
                </button>

            </div>

        </form>

    );

}

export default EmailSettings;